import { METHOD_NAMES } from './consts';
import Text from 'components/base/Text';
import Dropdown from 'components/base/Dropdown';
import Icon from 'components/base/Icon';
import { StyledSectionTitle } from './CreateEditProjectModal.style';
import styled from 'styled-components';

const StyledCadenceSelector = styled.div`
  margin-bottom: 2rem;
`;

const methodOptions = [
  {
    value: METHOD_NAMES.SCRUM.type,
    displayValue: (
      <>
        <Icon name='scrum' color='silverSand' />
        <Text size='x-medium' pl='0.5rem'>
          Scrum
        </Text>
      </>
    )
  },
  {
    value: METHOD_NAMES.KANBAN.type,
    displayValue: (
      <>
        <Icon name='kanban' color='silverSand' />
        <Text size='x-medium' pl='0.5rem'>
          Kanban
        </Text>
      </>
    )
  }
];

const CadenceSelector = ({ value, onChange }) => {
  return (
    <StyledCadenceSelector>
      <StyledSectionTitle>Methodology</StyledSectionTitle>
      <Dropdown
        options={methodOptions}
        onChange={onChange}
        height='2.45rem'
        selectedValue={value}
      />
    </StyledCadenceSelector>
  );
};

export default CadenceSelector;
